import { Button, Drawer, Form, Input, InputRef, Modal, Select, Space, Table, Tooltip } from "antd";
import { connect } from "react-redux";
import { AppState } from "src/store";
import style from './Tables.module.scss'
import { deleteEmissionSourceByTypeOrganization, deleteRegisterEmissionSourcesTypeEvent, getAllEmissionsTable, GetAllTypeEventByEmission, getEmissionsById, getEmissionSourceByTypeOrganizationId, getTypeEvent, postRegisterEmissionSourcesTypeEvent, postRegisterEmissionSourceTypeOrganization, postResgisterEmissions, putResgisterEmissions } from "src/store/emissions/thunks";
import { SearchOutlined, PlusCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, EditOutlined, CloudOutlined, DeliveredProcedureOutlined, TagOutlined } from '@ant-design/icons';
import { SizeType } from "antd/es/config-provider/SizeContext";
import validateMessages from "src/globals/Inputs/validateMessages";
import TextArea from "antd/es/input/TextArea";
import form from "antd/es/form";
import { NamePath } from "antd/es/form/interface";
import { EmissionsSource } from "src/store/emissions/types";
import { getAllCategoryTable } from "src/store/category/thunks";
import { Category } from "src/store/category/type";
import { validate100, validate150, validate255, validate60, validateDecimal4 } from "src/globals/Inputs/validateInput";
import { getAllPcg, GetPcgById, postRegisterPcg, putUpdatePcg, getPcgEmissions, postResgisterPcgEmissions, deletePcgEmissions } from "src/store/pcg/thunks";
import { GetTransformationByFilterFlow, GetTransformationById, getAllTransformation, getTransformationFactorsUnitByFlowAndSource } from "src/store/transformationfactors/thunks";
import { TransformationSource } from "src/store/transformationfactors/types";
import type { FilterConfirmProps } from 'antd/es/table/interface';
import type { ColumnsType, ColumnType } from 'antd/es/table';
import React, { useRef, useState, useEffect } from 'react';
import { formatNumberString } from "src/globals/Funciones/funciones";
import { getAllSourceTable, getSourceById } from "src/store/sources/thunks";
import { getAllTagTable, getTagById } from "src/store/tag/thunks";
import AdminHeader from "src/globals/Layout/Admin/AdminHeader";
import { getTypeOrganization, getTypeOrganizationsByEmissionSourceId } from "src/store/organization/thunks";
import { TypeOrganization } from "src/store/organization/types";



interface TableProps {
    getAllSourceTable?: any;
    getSourceById?: any;
    getAllTagTable?: any;
    getTagById?: any;
    getAllTransformation?: any;
    getAllPcg?: any;
    getTypeOrganization?:any;
    GetPcgById?: any;
    postRegisterPcg?: any;
    putUpdatePcg?: any;
    getPcgEmissions?: any;
    postResgisterPcgEmissions?: any;
    deletePcgEmissions?: any;
    getAllEmissionsTable?: any;
    getTypeEvent?: any;
    getEmissionsById?: any;
    postResgisterEmissions?: any;
    putResgisterEmissions?: any;
    getAllCategoryTable?: any;
    GetTransformationByFilterFlow?: any;
    GetTransformationById?: any;
    getTransformationFactorsUnitByFlowAndSource?: any;
    postRegisterEmissionSourcesTypeEvent?: any;
    deleteRegisterEmissionSourcesTypeEvent?: any;
    GetAllTypeEventByEmission?: any;
    postRegisterEmissionSourceTypeOrganization?:any;
    deleteEmissionSourceByTypeOrganization?:any;
    getTypeOrganizationsByEmissionSourceId?:any;
}

interface DataType {
    key: String;
    id: string;
    categoryId: string;
    category_name: string;
    name: string;
    type: string;
    flow: string;
    co2: number;
    ch4: number;
    n20: number;
    brand: string;
    tag: string;
    series: string;
    unit: string;
    description: string;
    sourceId: string;
    tagId: string;
}

interface PcgSource {
    id: string;
    name: string;
    compound: string;
    formula: string;
    pcgValue: number;
    created_at: string;
    updated_at: string;
    pcgEmissionId: string;
}

interface TypeEvent {
    id?: string;
    name: string;
    description: string;
    emissionSourcesTypeEventId?: string
}

interface Source {
    key: string;
    id: string;
    name: string;
    description: string;
    created_at: string;
    updated_at: string;
}

interface Tag {
    key: string;
    id: string;
    name: string;
    description: string;
    created_at: string;
    updated_at: string;
}

type DataIndex = keyof DataType;
type DataIndexPCG = keyof PcgSource;
type RequiredMark = boolean | 'optional';
const TEmissions: React.FC<TableProps> = (props: TableProps) => {
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef<InputRef>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isFormValidate, setIsFormValidate] = useState(true);
    const [typeModal, setTypeModal] = useState(true);
    const [idEmissions, setIdEmissions] = useState('');
    const [formValidate] = Form.useForm();
    const [formTypeEvent] = Form.useForm();
    const [category, setCategory] = useState([]);
    const [source, setSource] = useState([]);
    const [tag, setTag] = useState([]);
    const [factors, setFactors] = useState([]);
    const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const { Option } = Select;
    const [IsModalPcg, setIsModalPcg] = useState(false);
    const [IsModalTypeOrganization, setIsModalTypeOrganization] = useState(false);
    const [searchValue, setSearchValue] = useState<PcgSource>();
    const [searchValueType, setSearchValueType] = useState<TypeEvent>();
    const [dataType, setDataType] = useState<DataType>();

    const [searchValueFlow, setSearchValueFlow] = useState('');
    const [isId, setIsId] = useState("");
    const [dataTablePcg, setDataTablePcg] = useState([]);
    const [dataTableTypeEvent, setDataTableTypeEvent] = useState([]);
    const [selectDataTablePcg, setSelectDataTablePcg] = useState([]);
    const [selectDataTablTypeEvent, setSelectDataTableTypeEvent] = useState([]);
    const [isTableTypeOrganization, setIsTableTypeOrganization] = useState([]);
    const [isTableTypeOrganizationColumn, setIsTableTypeOrganizationColumn] = useState([]);
    const [IsModalTypeEvent, setIsModalTypeEvent] = useState(false);

    //LLamar al EndPoint tanto en el Interface como en el Map, 
    const init = async () => {

        const responseDataEmissions = await props.getAllEmissionsTable();
        setDataTable(responseDataEmissions);
        const responseDataCategory = await props.getAllCategoryTable();
        setCategory(responseDataCategory);
        const responseDataSource = await props.getAllSourceTable();
        setSource(responseDataSource);
        const responseDataTag = await props.getAllTagTable();
        setTag(responseDataTag);

    }

    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex,
    ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleSearchPCG = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndexPCG,
    ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
    };

    const getColumnSearchProps = (dataIndex: DataIndex, title: string): ColumnType<DataType> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Buscar ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reiniciar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },

    });


    //PABLo

    const getColumnSearchPropsPCG = (dataIndex: DataIndexPCG, title: string): ColumnType<PcgSource> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Buscar ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearchPCG(selectedKeys as string[], confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearchPCG(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reiniciar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },

    });

    useEffect(() => {
        init();
    }, []);

    function convertirNotacionCientificaANumeroCompleto(numero: string): number {
        return parseFloat(numero);
    }
    //Crear una tabla.
    const [dataTable, setDataTable] = useState([]);

    const columns: ColumnsType<DataType> = [
        {
            //cOMO YO QUIERO QUE APAREZCA
            title: 'Categoría',
            width: 25,
            //TA LCUAL COMO SE DECLARA EN EL DATATYPE
            dataIndex: 'category_name',
            //SE ENVIA EL MISMO QUE EL DATATYPE
            key: 'category_name',
            //MANTENER FORMATO
            //fixed: 'left',
            //BUSCADOR MODIFICADO PARA ESPANOL
            //...getColumnSearchProps('name', 'nombre'),
            ...getColumnSearchProps('category_name', 'category_name'),
            sorter: (a, b) => {
                const dateA = new Date(a.category_name);
                const dateB = new Date(b.category_name);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            title: 'Fuente',
            width: 20,
            dataIndex: 'name',
            key: 'name',
            //fixed: 'left',
            ...getColumnSearchProps('name', 'name'),
            sorter: (a, b) => {
                const dateA = new Date(a.name);
                const dateB = new Date(b.name);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            title: 'Tipo de fuente',
            width: 20,
            dataIndex: 'type',
            key: 'type',
            //fixed: 'left',
            ...getColumnSearchProps('type', 'type'),
            sorter: (a, b) => {
                const dateA = new Date(a.type);
                const dateB = new Date(b.type);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            title: 'Flujo',
            dataIndex: 'flow',
            key: 'flow',
            width: 20,
            sorter: (a, b) => {
                const dateA = new Date(a.flow);
                const dateB = new Date(b.flow);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            title: 'FE CO₂',
            dataIndex: 'co2',
            key: 'co2',
            width: 20,
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                const dateA = a.co2;
                const dateB = b.co2;
                return dateA - dateB;
            },
        },
        {
            title: 'FE CH₄',
            dataIndex: 'ch4',
            key: 'ch4',
            width: 20,
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                const dateA = a.ch4;
                const dateB = b.ch4;
                return dateA - dateB;
            },
        },
        {
            title: 'FE N₂O',
            dataIndex: 'n20',
            key: 'n20',
            width: 20,
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                const dateA = a.n20;
                const dateB = b.n20;
                return dateA - dateB;
            },
        },
        {
            title: 'Agrupación',
            dataIndex: 'brand',
            key: 'brand',
            width: 20,
            ...getColumnSearchProps('brand', 'brand'),
        },
        {
            title: 'Tag',
            dataIndex: 'tag',
            key: 'tag',
            width: 20,
            ...getColumnSearchProps('tag', 'tag'),
        },
        {
            title: 'Series',
            dataIndex: 'series',
            key: 'series',
            width: 20,
            ...getColumnSearchProps('series', 'series'),
        },
        {
            title: 'Unidad factor de emisión',
            dataIndex: 'unit',
            key: 'unit',
            width: 40,
            ...getColumnSearchProps('unit', 'unit'),
        },
        {
            title: 'Descripción',
            dataIndex: 'description',
            key: 'description',
            width: 20,
        },
        {
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 32,

            render: (record: DataType) =>
                <Space size="middle">
                    <Tooltip placement="topRight" title={validateMessages.typeOrganization} >
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => showTypeOrganization(record)}
                            icon={<TagOutlined />}
                        >

                        </Button>
                    </Tooltip>
                    <Tooltip placement="topRight" title={validateMessages.pcg} >
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => showPcgModalUpdate(record.id)}
                            icon={<CloudOutlined />}
                        >

                        </Button>
                    </Tooltip>

                    <Tooltip placement="topRight" title={validateMessages.typeEvent} >
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => handleTypeEvent(record)}
                            icon={<DeliveredProcedureOutlined />


                            }
                        />


                    </Tooltip>

                    <Tooltip placement="topRight" title={validateMessages.updateButton} >
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => handleTypeOpenModelUpdate(record.id)}
                            icon={<EditOutlined />}
                        />


                    </Tooltip>


                </Space>,
        },

    ];

    const columnsPcg: ColumnsType<PcgSource> = [
        {
            //cOMO YO QUIERO QUE APAREZCA
            title: 'Nombre',
            width: 25,
            //TA LCUAL COMO SE DECLARA EN EL DATATYPE
            dataIndex: 'name',
            //SE ENVIA EL MISMO QUE EL DATATYPE
            key: 'name',
            //MANTENER FORMATO
            //fixed: 'left',
            //BUSCADOR MODIFICADO PARA ESPANOL
            ...getColumnSearchPropsPCG('name', 'nombre'),
            sorter: (a, b) => {
                const dateA = new Date(a.name);
                const dateB = new Date(b.name);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            title: 'Compuesto',
            width: 20,
            dataIndex: 'compound',
            key: 'compound',
            //fixed: 'left',
            ...getColumnSearchPropsPCG('compound', 'Compuesto'),
            sorter: (a, b) => {
                const dateA = new Date(a.compound);
                const dateB = new Date(b.compound);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            title: 'PCG',
            dataIndex: 'pcgValue',
            key: 'pcgValue',
            width: 20,
            ...getColumnSearchPropsPCG('pcgValue', 'PCG'),
            sorter: (a, b) => {
                const dateA = new Date(a.pcgValue);
                const dateB = new Date(b.pcgValue);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            title: 'Acción',
            key: 'operation',
            fixed: 'right',
            width: 20,

            render: (record: PcgSource) =>
                <Space size="middle">
                    <Button
                        type="text"
                        className={style["danger-button"]}
                        onClick={() => deletePcgOrganiations(record.pcgEmissionId)}
                    >
                        Eliminar
                    </Button>

                </Space>,
        },


    ];

    const handleDeleteTypeOrganization = async (record: TypeOrganization) => {
        await props.deleteEmissionSourceByTypeOrganization(record.emissionTypeOrganization)
        const responseDataType = await props.getTypeOrganizationsByEmissionSourceId(dataType?.id);
        setIsTableTypeOrganizationColumn(responseDataType);
    };

    const columnsTypeOrganization: ColumnsType<TypeOrganization> = [
        {
            //cOMO YO QUIERO QUE APAREZCA
            title: '',
            width: 0,
            //TA LCUAL COMO SE DECLARA EN EL DATATYPE
            dataIndex: 'emissionTypeOrganization',
            //SE ENVIA EL MISMO QUE EL DATATYPE
            key: 'emissionTypeOrganization',
            //MANTENER FORMATO
            //fixed: 'left',
            //BUSCADOR MODIFICADO PARA ESPANOL
            render: () => null,

            
        },      
        {
            //cOMO YO QUIERO QUE APAREZCA
            title: 'Nombre',
            width: 25,
            //TA LCUAL COMO SE DECLARA EN EL DATATYPE
            dataIndex: 'name',
            //SE ENVIA EL MISMO QUE EL DATATYPE
            key: 'name',
            //MANTENER FORMATO
            //fixed: 'left',
            //BUSCADOR MODIFICADO PARA ESPANOL
            
        },      
       
        {
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 20,

            render: (record: TypeOrganization) =>
                <Space size="middle">
                    <Button
                        type="text"
                        className={style["danger-button"]}
                        onClick={() => handleDeleteTypeOrganization(record)}
                    >
                        Eliminar
                    </Button>

                </Space>,
        },


    ];
    const columnstypeEvent: ColumnsType<TypeEvent> = [
        {

            title: '',
            width: 0,
            dataIndex: 'id',
            key: 'id',
            render: () => null,


        },
        {

            title: '',
            width: 0,
            dataIndex: 'emissionSourcesTypeEventId',
            key: 'emissionSourcesTypeEventId',
            render: () => null,


        },


        {
            title: 'Nombre',
            width: 20,
            dataIndex: 'name',
            key: 'name',

        },
        {
            title: 'Descripción',
            dataIndex: 'description',
            key: 'description',
            width: 20,

        },
        {
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 20,

            render: (record: TypeEvent) =>
                <Space size="middle">
                    <Button
                        type="text"
                        className={style["danger-button"]}
                        onClick={() => deleteTypeEvent(record.emissionSourcesTypeEventId)}
                    >
                        Eliminar
                    </Button>

                </Space>,
        },


    ];
    const handleCancel = () => {
        formValidate.resetFields();
        setIsModalOpen(false)
    };
    const handleTypeOpenModel = () => {
        setIsModalOpen(true)
        setTypeModal(true)
    };

    //getTypeEvent


    const handleTypeEvent = async (value: DataType) => {
        setIsModalTypeEvent(true);
        setIsId(value.id);
        const responseData = await props.getTypeEvent();
        setSelectDataTableTypeEvent(responseData);
        const responseDataPcgTable = await props.GetAllTypeEventByEmission(value.id);
        setDataTableTypeEvent(responseDataPcgTable);

    };
    const handleTypeOpenModelUpdate = async (value: String) => {
        setIsModalOpen(true)
        setTypeModal(false)
        const responseData: EmissionsSource = await props.getEmissionsById(value);
        setIdEmissions(responseData.id)
        const responseDataTranfor = await props.GetTransformationById(responseData.transformationFactorsId);

        const numeroCompleto = convertirNotacionCientificaANumeroCompleto(responseData.ch4);

        formValidate.setFieldsValue({
            categoryId: responseData.categoryId,
            name: responseData.name,
            type: responseData.type,
            flowSelect: responseDataTranfor.flow + "/" + responseDataTranfor.source,
            co2: formatNumberString(responseData.co2, 7),
            ch4: formatNumberString(responseData.ch4, 7),
            n20: formatNumberString(responseData.n20, 7),
            brand: responseData.brand,
            tag: responseData.tag,
            series: responseData.series,
            unit: responseData.unit,
            description: responseData.description,
            sourceId: responseData.source_id,
            tagId: responseData.tag_id
        });
    };
    const onFormLayoutChange = ({ size }: { size: SizeType }) => {
        setComponentSize(size);
    };
    const onFinish = async (values: any) => {        
        if (!typeModal) {
            let arraySubcadenas: string[] = values.flowSelect.split('/');
            const responseData: TransformationSource = await props.getTransformationFactorsUnitByFlowAndSource(arraySubcadenas[0], arraySubcadenas[1]);
            const Emissions = {
                id: idEmissions,
                categoryId: values.categoryId,
                transformationFactorsId: responseData == undefined ? values.flowSelect : responseData.id,
                name: values.name,
                type: values.type,
                co2: values.co2,
                ch4: values.ch4,
                n20: values.n20,
                brand: values.brand == undefined ? ' ' : values.brand,
                tag: values.tag == undefined ? ' ' : values.brand,
                series: values.series == undefined ? ' ' : values.series,
                unit: "",
                description: values.description == undefined ? ' ' : values.description,
                source_id: values.sourceId,
                tag_id: values.tagId
            };
            await props.putResgisterEmissions(Emissions);
        } else {
            const Emissions = {
                //id: idEmissions,
                categoryId: values.categoryId,
                transformationFactorsId: values.flowSelect,
                name: values.name,
                type: values.type,
                co2: values.co2,
                ch4: values.ch4,
                n20: values.n20,
                brand: values.brand == undefined ? ' ' : values.brand,
                tag: values.tag == undefined ? ' ' : values.brand,
                series: values.series == undefined ? ' ' : values.series,
                unit: "",
                description: values.description == undefined ? ' ' : values.description,
                source_id: values.sourceId,
                tag_id: values.tagId
            };
            await props.postResgisterEmissions(Emissions);
        }
        handleCancel();
        const responseData = await props.getAllEmissionsTable();
        setDataTable(responseData);
        formValidate.resetFields();
    };
    const showPcgModalFalse = async () => {
        setIsModalPcg(false);
        setIsModalTypeEvent(false);
        setIsModalTypeOrganization(false);
    };
    const onRegisterPcg = async (values: any) => {
        const register = {
            emissionSourcesId: isId,
            pcgId: values.pcg,
        }
        await props.postResgisterPcgEmissions(register);

        const responseDataPcgTable = await props.getPcgEmissions(isId);
        setDataTablePcg(responseDataPcgTable);
    }
    const onRegisterTypeOrganization = async (values: any) => {
        const register = {
            EmissionSourceId: dataType?.id,
            TypeOrganizationId: values.typeorga,
        }
        await props.postRegisterEmissionSourceTypeOrganization(register);

        const responseDataType = await props.getTypeOrganizationsByEmissionSourceId(dataType?.id);
        setIsTableTypeOrganizationColumn(responseDataType);
    }
    

    const onRegisterTypeEvent = async (values: any) => {
        const register = {
            typeEventId: values.event,
            emissionSourcesId: isId,
        }
        await props.postRegisterEmissionSourcesTypeEvent(register);

        const responseDataPcgTable = await props.GetAllTypeEventByEmission(isId);
        setDataTableTypeEvent(responseDataPcgTable);
    }

    const showTypeOrganization = async (value: DataType) => {
        setIsModalTypeOrganization(true);
        setDataType(value);
        const responseDataTag = await props.getTypeOrganization();
        setIsTableTypeOrganization(responseDataTag);

        const responseDataType = await props.getTypeOrganizationsByEmissionSourceId(value.id);
        setIsTableTypeOrganizationColumn(responseDataType);
    
    };

    const showPcgModalUpdate = async (value: string) => {

        setIsModalPcg(true);
        setIsId(value);
        const responseDataPcg = await props.getPcgEmissions(value);
        setDataTablePcg(responseDataPcg);
        const responseDataPcgTable = await props.getAllPcg(value);
        setSelectDataTablePcg(responseDataPcgTable);

    };
    const deletePcgOrganiations = async (value: string) => {
        await props.deletePcgEmissions(value)
        const responseDataPcgTable = await props.getPcgEmissions(isId);
        setDataTablePcg(responseDataPcgTable);



    };
    const deleteTypeEvent = async (value: string | undefined) => {

        await props.deleteRegisterEmissionSourcesTypeEvent(value);

        const responseDataPcgTable = await props.GetAllTypeEventByEmission(isId);
        setDataTableTypeEvent(responseDataPcgTable);
    }
    const handleSearchFilter = async (value: string) => {

        setSearchValueFlow(value);
        if (value) {
            const responseDataFactors = await props.GetTransformationByFilterFlow(value);
            setFactors(responseDataFactors);
        } else {
            setFactors([]);
        }
    };

    return (
        <>
            <Button
                type="primary"
                icon={<PlusCircleOutlined />}
                className={style["create-button-user"]}
                onClick={handleTypeOpenModel}
            >
                Crear fuente de emisión
            </Button>
            <Table size="small" columns={columns} dataSource={dataTable} scroll={{ x: 1800 }} pagination={{ pageSize: 5 }} />
            <Drawer title={typeModal ? "Crear fuente de emisión" : "Actualizar fuente de emisión"} open={isModalOpen} onClose={handleCancel} width={350} footer={null}>
                <h3 className={style["title-modal"]}>
                </h3>
                <Form
                    form={formValidate}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onFinish}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    <Form.Item
                        label="Categoría"
                        name="categoryId"
                        rules={[{ required: true, message: validateMessages.emptyField }]}
                    >
                        <Select
                            showSearch
                            style={{ width: "100%" }}
                            filterOption={(input: any, option: any) =>
                                option && option.children && typeof option.children === 'string' &&
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            placeholder="Escoge la categoría"
                            options={category.map((item: Category) => ({ label: item.name, value: item.id }))}
                        />
                    </Form.Item>

                    <Form.Item label="Nombre" name="name" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate100(value) },
                    ]}>
                        <Input placeholder="Ingresar nombre de fuente de emisión" />
                    </Form.Item>
                    <Form.Item
                        label="Tipo de fuente"
                        name="type"
                        rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select placeholder="Seleccionar tipo de fuente">
                            <Option value="Fija">Fija</Option>
                            <Option value="Movil">Movil</Option>
                            <Option value="Fugitiva">Fugitiva</Option>
                            <Option value="Proceso">Proceso</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="Flujo" name="flowSelect" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate100(value) },
                    ]}>
                        <Select
                            showSearch
                            style={{ width: "100%" }}
                            onChange={(type: string) => setSearchValueFlow(type)}
                            onSearch={handleSearchFilter}
                            filterOption={false}
                            placeholder="Escoge el flujo"
                            options={factors.map((item: TransformationSource) => ({ label: item.flow + "/" + item.source, value: item.id }))}
                        />
                    </Form.Item>
                    <Form.Item tooltip={validateMessages.validateDecimals} label="FE CO₂" name="co2" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validateDecimal4(value) },
                    ]}>
                        <Input placeholder="Ingresar nivel de CO₂" />
                    </Form.Item>
                    <Form.Item tooltip={validateMessages.validateDecimals} label="FE CH₄" name="ch4" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validateDecimal4(value) },
                    ]}>
                        <Input placeholder="Ingresar nivel de CH₄" />
                    </Form.Item>
                    <Form.Item tooltip={validateMessages.validateDecimals} label="FE N₂O" name="n20" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validateDecimal4(value) },
                    ]}>
                        <Input placeholder="Ingresar nivel de N₂O" />
                    </Form.Item>
                    <Form.Item
                        label="Fuente"
                        name="sourceId"
                        rules={[{ required: true, message: validateMessages.emptyField }]}
                    >
                        <Select
                            showSearch
                            style={{ width: "100%" }}
                            filterOption={(input: any, option: any) =>
                                option && option.children && typeof option.children === 'string' &&
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            placeholder="Escoge la fuente"
                            options={source.map((item: Source) => ({ label: item.name, value: item.id }))}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Tag"
                        name="tagId"
                        rules={[{ required: true, message: validateMessages.emptyField }]}
                    >
                        <Select
                            showSearch
                            style={{ width: "100%" }}
                            filterOption={(input: any, option: any) =>
                                option && option.children && typeof option.children === 'string' &&
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            placeholder="Escoge el Tag"
                            options={tag.map((item: Tag) => ({ label: item.name, value: item.id }))}
                        />
                    </Form.Item>
                    <Form.Item label="Serie" name="series">
                        <Input placeholder="Ingresar la serie" />
                    </Form.Item>

                    <Form.Item label="Descripción" name="description">
                        <TextArea placeholder="Ingresar descripción" rows={4} />
                    </Form.Item>
                    <Form.Item>
                        <Button className={style["user-button"]} type="primary" htmlType="submit">
                            {typeModal ? "Ingresar" : "Actualizar"}
                        </Button>
                    </Form.Item>
                </Form>
            </Drawer>

            

            <Drawer open={IsModalTypeOrganization} width={950} footer={null} onClose={showPcgModalFalse}>
                <h3>Seleccionar Tipo de organización</h3>
                <Form
                    form={formValidate}
                    layout="inline"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onRegisterTypeOrganization}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    <Form.Item className={style["select-fe"]} name="typeorga" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select
                            showSearch
                            style={{ width: "100%" }}
                            onChange={(type: PcgSource) => setSearchValue(type)}
                            filterOption={(input: any, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }

                            value={searchValue}
                            placeholder="Escoga el tipo de organización"
                        >
                            {isTableTypeOrganization.map((type: TypeOrganization) => (
                                <Option key={`type-option-${type}`} value={type.id}
                                >
                                    {type.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item  >
                        <Button
                            htmlType="submit"
                            type="primary"
                            className={style["create-button-user-select"]}
                        >
                            Guardar selección
                        </Button>
                    </Form.Item>
                </Form>
                <Table size="small" columns={columnsTypeOrganization} dataSource={isTableTypeOrganizationColumn} scroll={{ x: 500 }} />
            </Drawer>
            <Drawer open={IsModalPcg} width={950} footer={null} onClose={showPcgModalFalse}>
                <h3>Seleccionar PCG</h3>
                <Form
                    form={formValidate}
                    layout="inline"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onRegisterPcg}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    <Form.Item className={style["select-fe"]} name="pcg" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select
                            showSearch
                            style={{ width: "100%" }}
                            onChange={(type: PcgSource) => setSearchValue(type)}
                            filterOption={(input: any, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }

                            value={searchValue}
                            placeholder="Escoga el factor de transformación"
                        >
                            {selectDataTablePcg.map((type: PcgSource) => (
                                <Option key={`type-option-${type}`} value={type.id}
                                >
                                    {type.name + " - " + type.compound + " - " + type.pcgValue}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item  >
                        <Button
                            htmlType="submit"
                            type="primary"
                            className={style["create-button-user-select"]}
                        >
                            Guardar selección
                        </Button>
                    </Form.Item>
                </Form>
                <Table size="small" columns={columnsPcg} dataSource={dataTablePcg} scroll={{ x: 500 }} />
            </Drawer>

            <Drawer open={IsModalTypeEvent} width={950} footer={null} onClose={showPcgModalFalse}>
                <AdminHeader>Seleccionar Tipo de evento</AdminHeader>
                <Form
                    form={formTypeEvent}
                    layout="inline"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onRegisterTypeEvent}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    <Form.Item className={style["select-fe"]} name="event" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select
                            showSearch
                            style={{ width: "100%" }}
                            onChange={(type: TypeEvent) => setSearchValueType(type)}
                            filterOption={(input: any, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }

                            value={searchValueType}
                            placeholder="Escoga el tipo de evento"
                        >
                            {selectDataTablTypeEvent.map((type: TypeEvent) => (
                                <Option key={`type-option-${type}`} value={type.id}
                                >
                                    {type.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item  >
                        <Button
                            htmlType="submit"
                            type="primary"
                            className={style["create-button-user-select"]}
                        >
                            Guardar selección
                        </Button>
                    </Form.Item>
                </Form>
                <Table size="small" columns={columnstypeEvent} dataSource={dataTableTypeEvent} scroll={{ x: 500 }} />
            </Drawer>
        </>
    );
};

const mapStateToProps = (state: AppState) => ({
});
export default connect(mapStateToProps, {
    getAllTransformation, getAllPcg, GetPcgById, postRegisterPcg, putUpdatePcg, getPcgEmissions, postResgisterPcgEmissions, deletePcgEmissions,
    getAllEmissionsTable, getEmissionsById, postResgisterEmissions, putResgisterEmissions, getAllCategoryTable,
    GetTransformationByFilterFlow, GetTransformationById, getTransformationFactorsUnitByFlowAndSource, getAllSourceTable, getSourceById, getAllTagTable, getTagById
    , getTypeEvent, postRegisterEmissionSourcesTypeEvent, deleteRegisterEmissionSourcesTypeEvent,
    GetAllTypeEventByEmission,getTypeOrganization,
    postRegisterEmissionSourceTypeOrganization,deleteEmissionSourceByTypeOrganization,
    getTypeOrganizationsByEmissionSourceId
})(TEmissions);

